import { headerConfig } from '../const'

export enum ClvrScreenControlHeadersLabelsEnum {
    INTERVENTION = 'intervention',
    HOURLY = 'hourly',
    START_HOURLY = 'hourly_start',
    END_HOURLY = 'hourly_end',
    MATERIAL = 'material',
    MATERIAL_LIST = 'material_list',
    MATERIAL_TO_PROVIDE = 'material_to_provide',
    REMARKS = 'remarks',
    TYPE_OF_ANESTHESIA = 'type_of_anesthesia',
    PATIENT = 'patient',
    PATIENT_NAME = 'patient_name',
    PATIENT_FIRSTNAME = 'firstname_patient',
    PATIENT_LASTNAME = 'lastname_patient',
    AGE_PATIENT = 'age_patient',
    SEX_PATIENT = 'sex_patient',
    SERVICE_PATIENT = 'service_patient',
    //@todo change to ROOM_PATIENT = 'room_patient'
    NB_ROOM_PATIENT = 'nb_room_patient',
    ADMISSION_TYPE_PATIENT = 'admission_type_patient',
    ISOLATION_PATIENT_TYPE = 'isol_info_patient',
    SURGEON = 'surgeon',
    ANESTHESIA = 'anesthesia',
    NURSE_INSTRUMENTALIST = 'nurse_instrumentalist',
    NURSE_INSTRUMENTALIST_AVATAR = 'nurse_instrumentalist_avatar',
    NURSE_ANESTHETIST = 'nurse_anesthetist',
    NURSE_ANESTHETIST_AVATAR = 'nurse_anesthetist_avatar',
    NURSE_ROOM_HELPERS = 'nurse_room_helpers',
    NURSE_ROOM_HELPERS_AVATAR = 'nurse_room_helpers_avatar',
    MATERIAL_AND_REMARK = 'material_and_remark',
    INTERVENTION_STATUS = 'intervention_status',
    INTERVENTION_AND_MATERIAL = 'intervention_and_material',
    INTERVENTION_AND_MATERIAL_LIST = 'intervention_and_material_list',
    INTERVENTION_AND_MATERIAL_TO_PROVIDE = 'intervention_and_material_to_provide',
    INTERVENTION_AND_REMARKS = 'intervention_and_remarks',
}

export const ClvrScreenControlHeadersConfig: Record<ClvrScreenControlHeadersLabelsEnum, headerConfig> = {
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION]: {},
    [ClvrScreenControlHeadersLabelsEnum.HOURLY]: {},
    [ClvrScreenControlHeadersLabelsEnum.START_HOURLY]: {},
    [ClvrScreenControlHeadersLabelsEnum.END_HOURLY]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_LIST]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_TO_PROVIDE]: {},
    [ClvrScreenControlHeadersLabelsEnum.REMARKS]: {},
    [ClvrScreenControlHeadersLabelsEnum.TYPE_OF_ANESTHESIA]: {},
    [ClvrScreenControlHeadersLabelsEnum.PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.PATIENT_NAME]: {},
    [ClvrScreenControlHeadersLabelsEnum.PATIENT_FIRSTNAME]: {},
    [ClvrScreenControlHeadersLabelsEnum.PATIENT_LASTNAME]: {},
    [ClvrScreenControlHeadersLabelsEnum.AGE_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.SEX_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.SERVICE_PATIENT]: {},
    //@todo change to ROOM_PATIENT = 'room_patient'
    [ClvrScreenControlHeadersLabelsEnum.NB_ROOM_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.ADMISSION_TYPE_PATIENT]: {},
    [ClvrScreenControlHeadersLabelsEnum.ISOLATION_PATIENT_TYPE]: {},
    [ClvrScreenControlHeadersLabelsEnum.SURGEON]: {},
    [ClvrScreenControlHeadersLabelsEnum.ANESTHESIA]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_INSTRUMENTALIST]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_INSTRUMENTALIST_AVATAR]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_ANESTHETIST]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_ANESTHETIST_AVATAR]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_ROOM_HELPERS]: {},
    [ClvrScreenControlHeadersLabelsEnum.NURSE_ROOM_HELPERS_AVATAR]: {},
    [ClvrScreenControlHeadersLabelsEnum.MATERIAL_AND_REMARK]: {},
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION_STATUS]: {},
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL]: {},
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL_LIST]: {},
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL_TO_PROVIDE]: {},
    [ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_REMARKS]: {},
}
